import { inject, Injector } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { from, map, switchMap } from 'rxjs';
import { UserRoleEnum } from '../enums/userrole.enum';
import { PlatformService } from '../services/platform.service';
import { AuthStateService } from '../services/auth-state.service';

export const CommunityUserGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const injector = inject(Injector);
  const platformService = inject(PlatformService);
  const router = inject(Router);
  const byPassRoles = [UserRoleEnum.AdminAllowImpersonation];
  
  if (!platformService.browser()) return true;


  return from(import('@auth0/auth0-angular'))
      .pipe(
        map((module) => module.AuthService),
        switchMap((AuthService) => {
          const service =  injector.get(AuthService);
          return service.user$;
        }),
        map((user) => {
          const id = `${route.paramMap.get('id')}`;
          if (byPassRoles.includes(user?.['https://seemylegacy.com/sml_role'])) {
            return true;
          }
          const communityId = `${user?.['https://seemylegacy.com/community_id']}`;
          if (user && communityId && communityId === id) {
            return true;
          }
          return handleUnauthenticated(router);
        })
      );

};

function handleUnauthenticated(router: Router): boolean {
  router.navigate(['/']);
  return false;
}
